import React from 'react';

import AllRewardsAdminPresentation from '../../presentation/AllRewardsAdminPresentation';

import useGetRewardsInfo from '../../hooks/useGetRewardsInfo.js';

// import './style.scss'
import { ReactComponent as PointsToSendIcon } from './../../../assets/svg/pointstosend.svg';
import { ReactComponent as RecipientIcon } from './../../../assets/svg/recipientOne.svg';
import { ReactComponent as RewardIcon } from './../../../assets/svg/rewardOne.svg';
import { ReactComponent as CalendarIcon } from './../../../assets/svg/calendar.svg';
import { ReactComponent as CalendarSilhouetteIcon } from './../../../assets/svg/calendar-silhouette.svg';

const AllRewardsAdminContainer = (props) => {
	const {
		allActivitiesInfo,
		allRewardsInfo,
		setSelectedFilter,
		selectedFilter,
		getAllRewardCSV,
	} = useGetRewardsInfo();

	const badgeSummary = [
		{
			cardColor: 'oklch(0.6757 0.187 349.98)',
			pointAmount: allRewardsInfo?.totalPoints,
			cardTitle: 'Total Points',
			Icon: PointsToSendIcon,
		},
		{
			cardColor: 'oklch(0.7903 0.136 192.97)',
			pointAmount: allRewardsInfo?.peerToPeerBadges,
			cardTitle: 'On-The-Spot Recognitions',
			Icon: RewardIcon,
		},
		{
			cardColor: 'oklch(0.58 0.26 295)',
			pointAmount: allRewardsInfo?.anniversaryBadges,
			cardTitle: 'Milestones',
			Icon: CalendarSilhouetteIcon,
		},
	];

	const engagementSummary = [
		{
			cardColor: 'oklch(0.2998 0.034 260.85)',
			pointAmount: allRewardsInfo?.Employees,
			cardTitle: 'Employees',
			Icon: PointsToSendIcon,
		},
		{
			cardColor: 'oklch(0.39 0.159 24.91)',
			pointAmount: allRewardsInfo?.allTimeShoutouts,
			cardTitle: <>Shoutout <br />(All Time)</>,
			Icon: RecipientIcon,
		},
		{
			cardColor: 'oklch(0.6144 0.1809 25.93)',
			pointAmount: allRewardsInfo?.lastThirtyDaysShoutouts,
			cardTitle: <>Shoutouts <br /> (Last 30 Days)</>,
			Icon: CalendarIcon,
		},
	];

	return (
		<AllRewardsAdminPresentation
			badgeSummary={badgeSummary}
			allActivitiesInfo={allActivitiesInfo}
			setSelectedFilter={setSelectedFilter}
			selectedFilter={selectedFilter}
			getAllRewardCSV={getAllRewardCSV}
			engagementSummary={engagementSummary}
			company={props?.company}
		/>
	);
};

export default AllRewardsAdminContainer;
